<template>
  <b-dropdown :value="value" @input="onPrioritySelected" aria-role="list">
    <!-- Button-->
    <button class="button" type="button" slot="trigger">
      <b-icon :icon="currentOption.icon"></b-icon>
      <span>
        <span class="has-text-grey-light">Priority:</span>
        {{ currentOption.label }}
      </span>
      <b-icon icon="menu-down"></b-icon>
    </button>

    <!-- Options to choose-->
    <b-dropdown-item v-for="p in options" :key="p.value" :value="p.value" aria-role="listitem">
      {{ p.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
  export default {
    name: "PrioritySelector",
    props: {
      value: { type: String, required: false, default: null }
    },
    data() {
      return {
        options: [
          { value: null, label: 'Any priority', icon: 'priority-high' },
          { value: '4', label: 'High', icon: 'priority-high' },
          { value: '7', label: 'Low', icon: 'priority-high' }
        ]
      }
    },
    computed: {
      currentOption () {
        return this.options.find(s => s.value === this.value)
      }
    },
    methods: {
      onPrioritySelected(value) {
        this.$emit('input', value)
      }
    }
  }
</script>
